export const routes = {
  goodreadsImport: '/goodreads-import',
  review: '/review',
  genres: '/genres',
}
